export default __webpack_public_path__ + "static/media/mars39.13304833.gif";